enum ActionTypes {
  RESET = "app/broadcaster/RESET",
  UPDATE_BROADCASTERS = "app/broadcaster/UPDATE_BROADCASTERS",
}

export default ActionTypes;
